/* D120 (Colin 1 Nov): shared listing bar (snippets/wwc-plp-bar) - Nike-style hide on scroll down / show on scroll up.
   Phones/tablets (<1024px): follows the header (html.wwc-hdr-up from wwc-mobile-polish.js), so header + bar leave and come back together.
   Desktop: own direction check. Never hides while the Filter & Sort panel is open or focus is in the bar. Transform only: no layout shift.
   Also refreshes the type-chip row after AJAX filtering (FoxTheme facet-update). */
(function () {
  if (window.__wwcPlpBar) return; window.__wwcPlpBar = 1;
  var mq = window.matchMedia('(max-width:1023px)');
  var html = document.documentElement;
  var bars = [], lastY = window.scrollY, acc = 0, ticking = false;

  function ty(el) { var t = getComputedStyle(el).transform; if (!t || t === 'none') return 0; var m = t.match(/matrix(3d)?\(([^)]+)\)/); if (!m) return 0; var v = m[2].split(','); return parseFloat(m[1] ? v[13] : v[5]) || 0; }
  /* where the visible header ends when it is shown (ignores the slide-up transform) */
  function headerBottom() {
    var h = document.querySelector('.header-section');
    if (!h) return 0;
    var cs = getComputedStyle(h);
    if (cs.position !== 'sticky' && cs.position !== 'fixed') return 0;
    var shift = ty(h), r = h.getBoundingClientRect(), b = r.bottom - shift;
    var parts = h.querySelectorAll('.header__top, .header__bottom');
    if (parts.length) {
      var pb = 0;
      parts.forEach(function (p) { if (getComputedStyle(p).visibility === 'hidden') return; var pr = p.getBoundingClientRect(); if (pr.height > 0) pb = Math.max(pb, pr.bottom - shift); });
      if (pb > 0) b = Math.min(b, pb);
    }
    if (r.top - shift > 1) return 0; /* header not stuck at the top (e.g. scrolled with the page) */
    return Math.max(0, Math.round(b));
  }
  function drawerOpen() { var d = document.getElementById('FacetDrawer'); return !!(d && d.hasAttribute('open')); }

  function setup(bar) {
    if (bar.__wwc) return; bar.__wwc = 1;
    var s = document.createElement('div'); s.className = 'wwc-plpbar__sentinel'; s.setAttribute('aria-hidden', 'true');
    bar.parentNode.insertBefore(s, bar);
    bar.__s = s; bars.push(bar);
    bar.addEventListener('focusin', function () { if (kbd(bar)) show(bar); });
  }
  function kbd(bar) { var ae = document.activeElement; try { return !!(ae && ae !== document.body && bar.contains(ae) && ae.matches(':focus-visible')); } catch (_) { return false; } }
  function show(bar) { bar.classList.remove('is-hidden'); }

  function update() {
    ticking = false;
    var y = Math.max(0, window.scrollY), d = y - lastY; lastY = y;
    if ((d > 0) !== (acc > 0)) acc = 0;
    acc += d;
    var mobile = mq.matches, top = headerBottom();
    bars.forEach(function (bar) {
      if (!bar.isConnected) return;
      var hidden = bar.classList.contains('is-hidden');
      if (!hidden) bar.style.setProperty('--wwc-plp-top', top + 'px');
      var t = parseFloat(bar.style.getPropertyValue('--wwc-plp-top')) || 0;
      var stuck = bar.__s.getBoundingClientRect().top < t - 1;
      bar.classList.toggle('is-stuck', stuck);
      var hide;
      if (!stuck || drawerOpen() || kbd(bar)) hide = false;
      else if (mobile) hide = html.classList.contains('wwc-hdr-up');
      else hide = acc > 24 ? true : (acc < -12 ? false : hidden);
      if (hide !== hidden) bar.classList.toggle('is-hidden', hide);
      if (!hide && hidden) bar.style.setProperty('--wwc-plp-top', top + 'px');
    });
  }
  function req() { if (!ticking) { ticking = true; requestAnimationFrame(update); } }

  /* type chips: re-rendered with the rest of the page after an AJAX filter / sort */
  function onFacet(e) {
    var txt = e && e.responseText; if (!txt) return;
    var doc = new DOMParser().parseFromString(txt, 'text/html');
    document.querySelectorAll('[data-wwc-plpbar]').forEach(function (bar) {
      var cur = bar.querySelector('[data-wwc-plpchips]');
      var brand = bar.querySelector('.wwc-plpbar__chips:not([data-wwc-plpchips])');
      if (brand) return; /* brand pages keep their own radio chips (sections/wwc-brand-page script) */
      var nb = doc.querySelector('[data-wwc-plpbar] [data-wwc-plpchips]');
      if (nb) nb.querySelectorAll('a[href]').forEach(function (a) { try { var u = new URL(a.getAttribute('href'), location.origin); u.searchParams.delete('section_id'); a.setAttribute('href', u.pathname + u.search); } catch (_) {} });
      if (cur && nb) cur.innerHTML = nb.innerHTML;
      else if (cur && !nb) cur.remove();
      else if (!cur && nb) bar.appendChild(document.importNode(nb, true));
    });
    req();
  }

  function init() {
    document.querySelectorAll('[data-wwc-plpbar]').forEach(setup);
    if (!bars.length) return;
    window.addEventListener('scroll', req, { passive: true });
    window.addEventListener('resize', req);
    new MutationObserver(req).observe(html, { attributes: true, attributeFilter: ['class'] });
    var d = document.getElementById('FacetDrawer');
    if (d) new MutationObserver(req).observe(d, { attributes: true, attributeFilter: ['open'] });
    document.addEventListener('collection:rerendered', req);
    try { if (window.FoxTheme && FoxTheme.pubsub) FoxTheme.pubsub.subscribe(FoxTheme.pubsub.PUB_SUB_EVENTS.facetUpdate, onFacet); } catch (_) {}
    /* first paint: no slide animation */
    bars.forEach(function (b) { b.classList.add('wwc-plpbar--notrans'); });
    update();
    requestAnimationFrame(function () { requestAnimationFrame(function () { bars.forEach(function (b) { b.classList.remove('wwc-plpbar--notrans'); }); }); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
